import userPages from './user';
import adminPages from './admin';

const menuItems = {
	items: [userPages, adminPages]
};

export default menuItems;
